import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

export default function ScrollRevealSection({ id, className = '', children, bg = '', style = {} }) {
  const [ref, visible] = useScrollReveal();
  return (
    <section
      id={id}
      ref={ref}
      style={style}
      className={`${className} ${bg} transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
    >
      {children}
    </section>
  );
}
